import './page/acris-blog-group-create';
import './page/acris-blog-group-detail';
import './page/acris-blog-group-list';

const { Module } = Shopware;

Module.register('acris-blog-group', {
    type: 'plugin',
    name: 'AcrisBlog',
    title: 'acris-blog-group.general.mainMenuItemGeneral',
    version: '1.0.0',
    targetVersion: '1.0.0',
    color: '#a6c836',
    icon: 'regular-list',
    favicon: 'icon-module-settings.png',

    routes: {
        index: {
            component: 'acris-blog-group-list',
            path: 'index',
            meta: {
                parentPath: 'acris.blogs.index'
            }
        },
        detail: {
            component: 'acris-blog-group-detail',
            path: 'detail/:id',
            meta: {
                parentPath: 'acris.blog.group.index'
            }
        },
        create: {
            component: 'acris-blog-group-create',
            path: 'create',
            meta: {
                parentPath: 'acris.blog.group.index'
            }
        }
    }
});
